import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { deactivateAccount } from 'actions/settings';
import { logoutUser } from 'actions/user';

import { CORRECT_CONFIRMATION_TEXT } from './constants';
import DeactivateAccountModalComponent from './DeactivateAccountModalComponent';

export class DeactivateAccountModalContainer extends Component {
  state = {
    confirmationText: '',
  }

  handleChange = (e) => {
    this.setState({
      confirmationText: e.target.value,
      canDeactivate: e.target.value === CORRECT_CONFIRMATION_TEXT,
    });
  }

  handleDeactivate = async () => {
    const { dispatch, history, onRequestClose } = this.props;
    const { canDeactivate } = this.state;
    if (!canDeactivate) {
      return;
    }
    await dispatch(deactivateAccount());
    onRequestClose();
    dispatch(logoutUser(history));
  }

  render = () => {
    const { isOpen, onRequestClose } = this.props;
    const { canDeactivate, confirmationText } = this.state;

    return (
      <DeactivateAccountModalComponent
        canDeactivate={canDeactivate}
        isOpen={isOpen}
        onChange={this.handleChange}
        onRequestClose={onRequestClose}
        onDeactivate={this.handleDeactivate}
        value={confirmationText}
      />
    );
  }
}

export default withRouter(connect()(DeactivateAccountModalContainer));